import { render, staticRenderFns } from "./BookingPriceComputing.vue?vue&type=template&id=d206d716&scoped=true"
import script from "./BookingPriceComputing.vue?vue&type=script&lang=js"
export * from "./BookingPriceComputing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d206d716",
  null
  
)

export default component.exports